// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--DxaZ_","prefix":"_2787e5dfdf--prefix--vfnbc","postfix":"_2787e5dfdf--postfix--GIA7a"};